const KEY = 'chroma.solo.best';

interface SoloRecord {
  score: number;
  accuracy: number;
  bestReactionMs: number | null;
  protocol: number;
  at: number;
}

export function loadSoloRecord(): SoloRecord | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<SoloRecord>;
    if (typeof parsed.score !== 'number') return null;
    return {
      score: parsed.score,
      accuracy: Number(parsed.accuracy ?? 0),
      bestReactionMs:
        typeof parsed.bestReactionMs === 'number' ? parsed.bestReactionMs : null,
      protocol: Number(parsed.protocol ?? 1),
      at: Number(parsed.at ?? Date.now()),
    };
  } catch {
    return null;
  }
}

export function saveSoloRecord(record: SoloRecord): boolean {
  const previous = loadSoloRecord();
  const isBest = !previous || record.score > previous.score;
  if (!isBest) return false;
  try {
    localStorage.setItem(KEY, JSON.stringify(record));
  } catch {
    return false;
  }
  return true;
}

export type { SoloRecord };
